import api from '../api/api';

export function SaveToNewPartsList(partsListName, articleId, quantity) {
  const saveToPartsListUrl = `/web/services/product/partslist/${partsListName}/${articleId}/${quantity}`;

  return api.put(saveToPartsListUrl, null)
    .catch(exception => {
      const error = exception;
      error.statusText = `Call to SaveToPartsListUrl with ${saveToPartsListUrl} failed. ${exception.statusText}`;
      return Promise.reject(error);
    });
}

export function SaveToExistingPartsList(partsListName, articleId, quantity) {
  const saveToPartsListUrl = `/web/services/product/partslist/${partsListName}/${articleId}/${quantity}`;

  return api.post(saveToPartsListUrl, null)
    .catch(exception => {
      const error = exception;
      error.statusText = `Call to SaveToPartsListUrl with ${saveToPartsListUrl} failed. ${exception.statusText}`;
      return Promise.reject(error);
    });
}

export function GetPartsList() {
  const getPartsListUrl = '/web/services/product/partslist/';

  return api.get(getPartsListUrl)
    .catch(exception => {
      const error = exception;
      error.statusText = `Call to GetPartsListUrl with ${getPartsListUrl} failed. ${exception.statusText}`;
      return Promise.reject(error);
    });
}



// WEBPACK FOOTER //
// ./src/main/ui/react/shared/services/PartsList/PartsList.js